// extracted by mini-css-extract-plugin
module.exports = {"tagWrap":"productTag_tagWrap__owmX6","tagIco":"productTag_tagIco__KNdGK"};